import { IDatiqInput, IDatiqOption } from '@dat/datiq-components-pkg/utils';

export interface IDatiqSelect extends IDatiqInput {
    options: IDatiqOption[];
    multiple: boolean;
    style?: DatiqSelectEnumStyle;
    appearance?: DatiqSelectEnumAppearance;
    tooltipClass?: string;
    overrideLabel?: boolean;
}

export type DatiqSelectTypesSelect = string | string[] | null;
export type DatiqSelectTypesInput = IDatiqOption | IDatiqOption[] | null;
export enum DatiqSelectEnumAppearance {
    Standard = 'standard',
    Outline = 'outline',
    Dark = 'dark',
}

export enum DatiqSelectEnumStyle {
    Standard = 'standard',
    Thin = 'thin',
    Dark = 'dark',
}
